var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoBrightness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03843,0,0,1.03219,-0.246114,-0.22661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.793,22.793L8.567,19.596L4.089,19.596L4.089,15.091L0.911,11.845L4.089,8.6L4.089,4.095L8.567,4.095L11.793,0.898L15.019,4.095L19.497,4.095L19.497,8.6L22.675,11.845L19.497,15.091L19.497,19.596L15.019,19.596L11.793,22.793ZM11.793,20.08L14.2,17.658L17.571,17.658L17.571,14.267L19.978,11.845L17.571,9.423L17.571,6.032L14.2,6.032L11.793,3.61L9.385,6.032L6.015,6.032L6.015,9.423L3.607,11.845L6.015,14.267L6.015,17.658L9.385,17.658L11.793,20.08Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03843,0,0,1.03219,-0.246114,-0.22661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.793,16.689C13.125,16.689 14.261,16.217 15.2,15.273C16.138,14.328 16.608,13.186 16.608,11.845C16.608,10.505 16.138,9.363 15.2,8.418C14.261,7.474 13.125,7.001 11.793,7.001L11.793,16.689Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBrightness);
export default __webpack_public_path__ + "static/media/picto-brightness.635dd5a4957f9ba861ce59d1a8c1d414.svg";
export { ForwardRef as ReactComponent };